(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/account-selector/assets/javascripts/account-selector-render.js') >= 0) return;  svs.modules.push('/components/marketplace/account-selector/assets/javascripts/account-selector-render.js');

'use strict';

const {
  AccountSelectorContainer
} = svs.components.marketplace.accountSelector;
const render = (classSelector, options) => {
  ReactDOM.render(
  React.createElement(AccountSelectorContainer, options), document.querySelector(classSelector));
};
setGlobal('svs.components.marketplace.accountSelector.render', render);

 })(window);